import { useMediaQuery } from '@mui/material'
import theme from 'features/common/ui/theme/cartoTheme'

// TODO: this seems broken, https://app.shortcut.com/cartoteam/story/485534
// most of builder this uses cssSmallMobileBreakpoint
// RightSidePanel is using cssMobileBreakpoint
// RightPane is using cssMobileBreakpoint & cssDesktopBreakpoint
// BuilderToolBar is using cssMobileBreakpoint

function useMobileBuilder() {
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })
}

export const cssDesktopBreakpoint = theme.breakpoints.up('md')
export const cssMobileBreakpoint = theme.breakpoints.down('md')
export const cssSmallMobileBreakpoint = theme.breakpoints.down('sm')

export default useMobileBuilder
